import readXlsxFile from 'read-excel-file'
import writeXlsxFile from 'write-excel-file'
import {TextFormData} from "./TradeInAppTexts";

const NAME_AREA = 'Area';
const NAME_LOCALIZATION_KEY = 'TextKey';

export const ExportToExcel = async (languages: string[], data: TextFormData[]) => {
   const objects = data.map(dat => {
      return dat.data
         .filter(d => !d.duplicate) // Skip duplicate keys - only export first occurrence
         .map(d => {
            const object: any = {
               area: dat.header.title,
               key: d.key
            };
            for (const language of languages) {
               object[language] = d.values[language].text
            }
            return object
         });
   }).flat();

   // @ts-ignore
   const schema = [{
      column: NAME_AREA,
      type: String,
      value: (object: any) => object.area
   }, {
      column: NAME_LOCALIZATION_KEY,
      type: String,
      value: (object: any) => object.key
   }];

   for (const language of languages) {
      schema.push({
         column: language,
         type: String,
         value: (object: any) => object[language]
      })
   }

   await writeXlsxFile(objects, {
      schema,
      fileName: 'translations-' + Date.now() + '.xlsx'
   })
}


export type ImportResult = {
   data: TextFormData[]
   duplicateKeys: string[] // Keys that appeared in multiple sections
}

export const ImportFromExcel = async (file: File): Promise<ImportResult> => {
   const rows = await readXlsxFile(file);

   const languages: string[] = [];
   const result: TextFormData[] = [];

   for (let row = 0; row < rows.length; row++) {
      const cells = rows[row];
      if (row === 0) {
         //
         // Header row
         //
         for (let i = 0; i < cells.length; i++) {
            if (i === 0) {
               if (cells[i] !== NAME_AREA) throw new Error('File is missing area column')
            } else if (i === 1) {
               if (cells[i] !== NAME_LOCALIZATION_KEY) throw new Error('File is missing localization key column')
            } else {
               let cellAsText = cells[i] as string;
               if (cellAsText) {
                  languages.push(cellAsText);
               }
            }
         }
      } else {
         //
         // Data cells
         //

         const area = cells[0] as string;
         const key = cells[1] as string;

         // Skip rows with missing area or key
         if (!area || !key) {
            continue;
         }

         // Find header
         let formData = result.find(res => res.header.title === area)
         if(!formData) {
            formData = {
               header: {
                  title: area,
                  description: ''
               },
               data: []
            }
            result.push(formData);
         }

         // Find key
         let dataKey = formData.data.find(dat => dat.key === key);
         if(!dataKey) {
            dataKey = {
               key: key,
               values: {},
               defaults: null
            }
            formData.data.push(dataKey);
         }

         // Add languages
         for (let i = 0; i < languages.length; i++) {
            const language = languages[i];
            const translation = cells[2 + i];
            dataKey.values[language] = {
               text: translation != null ? String(translation) : '',
               default: null,
               inherited: false
            }
         }
      }
   }

   // Detect duplicate keys across sections
   const keyToSections: Map<string, string[]> = new Map();
   for (const section of result) {
      for (const item of section.data) {
         const sections = keyToSections.get(item.key) || [];
         sections.push(section.header.title);
         keyToSections.set(item.key, sections);
      }
   }

   const duplicateKeys: string[] = [];
   keyToSections.forEach((sections, key) => {
      if (sections.length > 1) {
         duplicateKeys.push(key);
      }
   });

   return { data: result, duplicateKeys };
}